<template>
  <div class="app">
  	<!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>

    <br>
    <!-- BTN AJOUT -->
    <v-spacer></v-spacer>
    <div class="text-xs-right">
      <v-tooltip top>
        <v-btn slot="activator" icons color="blue" @click.stop="dialogAjout = true;" dark>Ajouter <v-icon right>add</v-icon></v-btn>
        Ajouter un nouveau produit
      </v-tooltip>
    </div>

    <!-- MODAL AJOUT DE PRODUIT -->
    <v-dialog v-model="dialogAjout" max-width="100%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Ajouter un nouveau produit</span> 
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation id="formProduct">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md3>
                  <v-text-field label="Libelle du produit" name="libelleProduit" v-model="libelleProduit" required></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field label="Reference du produit" name="referenceProduit" v-model="referenceProduit"></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-select label="Type" name="typeProduit" v-bind:items="listType" v-model="typeProduit" item-value="value"></v-select>
                </v-flex>
                <v-flex md3>
                  <v-text-field label="Prix du produit" name="prixProduit" v-model="prixProduit"></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-text-field label="Description du produit" name="descProduit" v-model="descProduit"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>          

            <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="blue" @click="addProduct" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL MODIFICATION DE PRODUIT -->
    <v-dialog v-model="dialogEdit" max-width="100%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Modification du produit </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogEdit = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="validEdit" ref="form" lazy-validation id="formEditProduct">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md3>
                  <v-text-field label="Libelle du produit" name="libelleEditProduit" v-model="libelleEditProduit" :rules="libelleRules" :counter="4" required></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-text-field label="Reference du produit" name="referenceEditProduit" v-model="referenceEditProduit"></v-text-field>
                </v-flex>
                <v-flex md3>
                  <v-select label="Type" name="typeEditProduit" v-bind:items="listType" v-model="typeEditProduit" item-value="value"></v-select>
                </v-flex>
                <v-flex md3>
                  <v-text-field label="Prix du produit" name="prixEditProduit" type="number" v-model="prixEditProduit"></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-text-field label="Description du produit" name="descEditProduit" v-model="descEditProduit"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>          

            <v-btn @click="clear" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="blue" @click="updateProduct" :disabled="!validEdit" dark>Modifier <v-icon right>add</v-icon></v-btn>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW -->
    <v-dialog v-model="dialogShow" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails du produit {{currentProduct.libelle}} </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <el-col :span="20">
              <div class="grid-content bg-purple">
                <el-card class="box-card"  style="background:#F9FAFC">
                  <div slot="header" class="carte-header">
                    <v-flex text-xs-center layout align-center justify-center>
                    </v-flex>
                  </div>
                  <div class="text item">
                    <p><b>Reference : </b> {{currentProduct.reference}} </p>
                    <p><b>Libelle : </b> {{currentProduct.libelle}} </p>
                    <p><b>Type : </b> {{currentProduct.type}} </p>
                    <p><b>Prix unitaire : </b> {{currentProduct.valeur}} FCFA</p>
                    <p><b>Description :</b> {{currentProduct.description}} </p>
                    <p><b>Date d'enrégistrement :</b> {{ currentProduct.created }} </p>
                    <p><b>Date de modification :</b> {{ currentProduct.modified }} </p>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer ce produit ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="red" @click.stop="deleteProduct" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- TABLEAU -->
    <v-card>
      <div>
        <v-card-title>
          <v-chip text-color="white" label color="primary">
            LISTE DES PRODUITS <v-icon right>account_circle</v-icon>
          </v-chip>
          <v-spacer></v-spacer>
          <v-text-field append-icon="search" label="Rechercher" single-line hide-details v-model="recherche"></v-text-field>
        </v-card-title>        
        <v-card-text>
          <v-data-table v-bind:headers="headers" v-bind:search="recherche" v-bind:pagination.sync="pagination" :items="listProduct" hide-actions class="elevation-1">
            <template slot="items" scope="props">
              <td class="text-xs-right">{{ props.item.libelle }}</td>
              <td class="text-xs-right">{{ props.item.reference }}</td>
              <td class="text-xs-right">{{ props.item.type }}</td>
              <td class="text-xs-right">{{ props.item.valeur }} FCFA</td>
              <td class="text-xs-center">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="showProduct(props.item)" fab dark small color="green">
                      <v-icon dark>folder_open</v-icon>
                    </v-btn>
                    Détails
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="editProduct(props.item)" fab dark small color="blue">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    Modifier
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="activeDeleteProduct(props.item)" fab dark small color="red">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </div>
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>      
        </v-card-text>        
      </div>
    </v-card>

  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        headers: [
          { text: 'Libelle', value: '', sortable: true },
          { text: 'Reference', value: '', sortable: true },
          { text: 'Type', value: '', sortable: true },
          { text: 'Prix', value: '', sortable: true },
          { text: 'Actions', align: 'center', value: '' }
        ],
        racourcis: [
          { path: '/', text: 'Accueil', disabled: false },
          { path: '/produit', text: 'Liste des produits', disabled: true }
        ],
        items: [
          { value: false, libelle: '', reference: '', type: '', prix: '', action: '' }
        ],
        recherche: '',
        libelleProduit: '',
        libelleEditProduit: '',
        referenceProduit: '',
        referenceEditProduit: '',
        typeProduit: '',
        typeEditProduit: '',
        prixProduit: '',
        prixEditProduit: '',
        descProduit: '',
        descEditProduit: '',
        pagination: {},
        valid: true,
        validEdit: true,
        dialogAjout: false,
        dialogEdit: false,
        dialogSupr: false,
        dialogShow: false,
        idProduit: '',
        listType: [
          { text: 'Materiel', value: 'materiel' },
          { text: 'Materiaux', value: 'materiaux' }
        ],
        listProduct: [],
        currentProduct: {},
        libelleRules: [
          (v) => !!v || 'Le libelle est obligatoire'
        ]
      }
    },
    computed: {
      pages () {
        return this.pagination.rowsPerPage ? Math.ceil(this.listProduct.length / this.pagination.rowsPerPage) : 0
      }
    },
    mounted () {
      this.loadPage()
      this.loadProduct()
    },
    methods: {
      loadPage () {
        const loading = this.$loading({
          lock: true,
          text: 'Veuillez patientez ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 1000)
      },
      addProduct () {
          var form = document.getElementById('formProduct')
          var formdata = new FormData(form)
          let url = this.domaine +'product/create-product'
          formdata.append('typeProduit', this.typeProduit)
          var request = new XMLHttpRequest()
          request.open('post', url)
          request.send(formdata)
          this.valid = false
          request.onreadystatechange = () => {
            let verif = JSON.parse(request.responseText)
            if (request.readyState === request.DONE) {
              if (request.status === 200) {
                if (verif[0].code === 2) {
                  this.$notify({
                    title: 'LE PRODUIT A BIEN ETE AJOUTE',
                    message: 'Enrégistrement réussie avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                  this.valid = true
                  this.dialogAjout = false
                  this.listProduct = verif[1]
                } else if (verif[0].code === 1) {
                  this.valid = true
                  this.$message.error(verif[0].message)
                }
              }
            }
          }
      },
      loadProduct () {
        let url = this.domaine +'product/product-list'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listProduct = response.body
          }
        })
      },
      showProduct (current) {
        this.dialogShow = true
        this.currentProduct = current
      },
      editProduct (current) {
        this.dialogEdit = true
        this.currentProduct = current
        this.libelleEditProduit = this.currentProduct.libelle
        this.referenceEditProduit = this.currentProduct.reference
        this.typeEditProduit = this.currentProduct.type
        this.prixEditProduit = this.currentProduct.valeur
        this.descEditProduit = this.currentProduct.description
      },
      updateProduct () {
        if (this.$refs.form.validate()) {
          var form = document.getElementById('formEditProduct')
          var formdata = new FormData(form)
          let url = this.domaine +'product/update-product/' + this.currentProduct.id
          formdata.append('typeEditProduit', this.typeEditProduit)
          var request = new XMLHttpRequest()
          request.open('post', url)
          request.send(formdata)
          this.validEdit = false
          request.onreadystatechange = () => {
            let verif = JSON.parse(request.responseText)
            if (request.readyState === request.DONE) {
              if (request.status === 200) {
                if (verif[0].code === 2) {
                  this.$notify({
                    title: 'LE PRODUIT A BIEN ETE MODIFIE',
                    message: 'Modification réussie avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                  this.validEdit = true
                  this.dialogEdit = false
                  this.listProduct = verif[1]
                } else if (verif[0].code === 1) {
                  this.validEdit = true
                  this.$message.error(verif[0].message)
                }
              }
            }
          }
        }
      },
      activeDeleteProduct (current) {
        this.dialogSupr = true
        this.idProduit = current.id
      },
      deleteProduct () {
        let url = this.domaine +'product/delete-product/' + this.idProduit
        var request = new XMLHttpRequest()
        request.open('get', url)
        request.send()
        this.dialogSupr = false
        request.onreadystatechange = () => {
          let verif = JSON.parse(request.responseText)
          if (request.readyState === request.DONE) {
            if (request.status === 200) {
              if (verif[0].code === 2) {
                this.$notify({
                  title: 'LE PRODUIT A BIEN ETE SUPPRIME',
                  message: 'Suppression réussie avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                this.dialogSupr = false
                this.listProduct = verif[1]
              } else if (verif[0].code === 1) {
                this.$message.error(verif[0].message)
              }
            }
          }
        }
      },
      clear () {
        this.$refs.form.reset()
        this.dialogAjout = false
        this.dialogEdit = false
        this.dialogSupr = false
      },
      beforeMount: function () {
        if(!this.roleAcces[this.$router.history.current.name]){
          this.$router.push({ name: 'Home'  })
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Produit.vue